import React from "react";
import "./RelatedProduct.css";

const RelatedProduct = ({ product }) => {
  const totalStock = product.stock.reduce(
    (acc, item) => acc + parseInt(item.quantity, 10),
    0
  );

  // Same crossfade as the grid card: a decorative second photograph layered
  // over the first at opacity 0. If it is missing or fails to load, the card
  // behaves exactly as it did before.
  const images = Array.isArray(product.images) ? product.images : [];
  const secondImage = images[1];

  return (
    <div className="product-card related-card">
      <div className="product-image-wrapper">
        {totalStock <= 0 && <div className="sold-out-badge">Sold Out</div>}
        <img
          className="product-img"
          src={`https://riymay.com/assets/${product.images[0]?.url}`}
          alt={product.images[0]?.altText || product.name}
          loading="lazy"
        />
        {secondImage?.url && (
          <img
            className="product-img product-img-alt"
            src={`https://riymay.com/assets/${secondImage.url}`}
            alt=""
            aria-hidden="true"
            loading="lazy"
          />
        )}
        <div className="product-hover-overlay">
          <button className="quick-shop-btn">Quick Shop</button>
          <div className="sizes-product">
            {product.stock.map((stockItem) => (
              <button
                key={stockItem._id}
                className="size-button-product"
                disabled={stockItem.quantity <= 0}
              >
                {stockItem.size}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="product-details">
        <p className="product-card-name">
          {product.name.length > 20
            ? `${product.name.substring(0, 20)}...`
            : product.name}
        </p>
        <p className="product-price">&#8377;{product.price}</p>
      </div>
    </div>
  );
};

export default RelatedProduct;
